// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const t = require('app/scripts/views/internal/teacupWithHelpers').teacupWithHelpers(
  'board_header',
);

const { featureFlagClient } = require('@trello/feature-flag-client');

module.exports = t.renderable(function ({
  canRename,
  orgLogoUrl,
  orgLogoUrl2x,
  isStandard,
  isBusinessClass,
  isRetiredBusinessClass,
  isEnterprise,
  orgDisplayName,
  name,
  orgName,
  isLoggedIn,
  isAdmin,
  isMember,
  isPrivateTeam,
  isUntitled,
  canJoin,
  canInviteMembers,
  canAssign,
  showCopyButton,
  isPrivateTeamForEnterpriseVisibleBoard,
  isTemplate,
  starTooltipKey,
  hasEditPrivileges,
  shareRenameEnabled,
  newSwitcherEnabled,
}) {
  const boardType = isStandard
    ? 'STA'
    : isBusinessClass
    ? 'BC'
    : isEnterprise
    ? 'ENT'
    : 'Free';

  const classes = {
    'board-header-btn': true,
    'mod-board-name': true,
    'inline-rename-board': true,
    'js-rename-board': canRename,
    'no-edit': !canRename,
    'should-rename': isUntitled && canRename,
  };

  const displayNameClasses = {
    'board-header-btn': true,
    'board-header-btn-org-name': true,
    'js-open-org-menu': true,
    'board-header-btn-without-icon': !orgLogoUrl,
  };

  const isPluginCleanupEnabled = featureFlagClient.get(
    'ecosystem.pup-header-cleanup',
    false,
  );
  if (!newSwitcherEnabled) {
    t.div('.js-board-views-btn-container');
  }

  t.div({ href: '#', class: t.classify(classes) }, function () {
    t.h1(
      '.js-board-editing-target.board-header-btn-text',
      { dir: 'auto' },
      () => t.text(name),
    );

    return t.input('.board-name-input.js-board-name-input', {
      'aria-label': name,
      spellcheck: 'false',
      dir: 'auto',
      maxLength: 512,
      value: name,
    });
  });

  if (isTemplate) {
    t.div('.board-header-btn-template-badge.js-board-template-badge');
  }

  if (isLoggedIn) {
    t.a(
      '.board-header-btn.js-star-board.board-header-star-container',
      {
        href: '#',
        title: t.l(starTooltipKey),
        'aria-label': t.l('star-or-unstar-board'),
      },
      () => t.icon('star', { class: 'board-header-btn-icon' }),
    );
  }

  t.div(
    '.js-board-header-btn-org-wrapper.board-header-btn-org-wrapper',
    function () {
      if (orgDisplayName && orgName) {
        t.span('.board-header-btn-divider');
        t.a(
          {
            href: `/${orgName}`,
            class: t.classify(displayNameClasses),
            data: { boardtype: boardType },
          },
          function () {
            if (orgLogoUrl) {
              t.div('.board-header-btn-name-org-logo-container', () =>
                t.img({
                  class: 'board-header-btn-name-org-logo',
                  src: orgLogoUrl,
                  srcSet: `${orgLogoUrl} 1x, ${orgLogoUrl2x} 2x`,
                }),
              );
            }
            return t.span('.board-header-btn-text', function () {
              t.text(orgDisplayName);
              if (isRetiredBusinessClass) {
                t.span('.org-label', () => t.text(boardType));
              }
            });
          },
        );
        t.span('.board-header-btn-divider');
      }

      t.div('.board-header-btns.mod-left', function () {
        if (!orgDisplayName && !isTemplate) {
          t.span('.board-header-btn-divider');
          if (
            (isMember && isPrivateTeam) ||
            isPrivateTeamForEnterpriseVisibleBoard
          ) {
            t.span(
              '.board-header-btn.board-header-btn-without-icon.board-header-btn-text.no-edit',
              () => t.format('private-workspace'),
            );
            return t.span('.board-header-btn-divider');
          } else if (!isPrivateTeam && !isTemplate) {
            t.a(
              '.board-header-btn.board-header-btn-without-icon.js-add-board-to-team',
              { href: '#', class: t.classify({ 'no-edit': !isAdmin }) },
              () =>
                t.span('.board-header-btn-text', () => t.format('personal')),
            );
          }
        }
      });

      return t.a('.board-header-btn.perms-btn.js-change-vis', {
        href: '#',
        id: 'permission-level',
      });
    },
  );

  t.span('.board-header-btn-divider');

  t.div('.board-header-btns.mod-left', function () {
    t.div('.board-header-facepile.js-fill-facepile', {
      class: t.classify({ 'js-list-draggable-board-members': canAssign }),
    });

    t.a(
      '#member-count.board-header-btn.board-header-btn-member-count.js-open-show-all-board-members.js-fill-board-member-count',
      { href: '#' },
      function () {},
    );
    t.span('#member-count-notifications');

    if (canInviteMembers) {
      featureFlagClient.get('smoothie.board-invite-popover', false) &&
      featureFlagClient.get('smoothie.board-share-spotlight', false)
        ? t.span('.board-share-button')
        : t.a(
            '.board-header-btn-invite.js-open-manage-board-members',
            {
              href: '#',
              title: t.l(shareRenameEnabled ? 'share' : 'invite-to-board'),
            },
            function () {
              t.icon('add-member', { class: 'board-header-btn-icon' });
              return t.span('.board-header-btn-text', () =>
                t.format(shareRenameEnabled ? 'share' : 'invite'),
              );
            },
          );
    }

    if (canJoin && !isTemplate) {
      return t.a(
        '.board-header-btn.board-header-btn-without-icon.board-header-btn-join-board.js-join-board',
        { href: '#', title: t.l('workspace-members-can-join-this-board') },
        () =>
          // hovertext to replace helper
          t.span('.board-header-btn-text', () => t.format('join-board')),
      );
    }
  });
  if (newSwitcherEnabled) {
    t.span('.board-header-btn-divider');
    t.div('.js-board-views-switcher');
  }

  t.div('.board-header-btns.mod-right', function () {
    if (isPluginCleanupEnabled) {
      t.span('.js-pup-header-btns board-header-btn-react-container');
    }

    t.a(
      '.board-header-btn.sub-btn.hide.js-board-header-subscribed',
      { href: '#' },
      function () {
        t.icon('subscribe', { class: 'board-header-btn-icon' });
        return t.span('.board-header-btn-text', () => t.format('watch'));
      },
    );

    t.span('.js-calendar-board-btn board-header-btn-react-container');

    t.a('.board-header-btn.hide.js-map-btn', { href: '#' }, function () {
      t.span('.icon-sm.icon-location.board-header-btn-icon');
      return t.span('.board-header-btn-text', () => t.format('map'));
    });

    if (!isPluginCleanupEnabled) {
      t.span('.js-butler-header-btns board-header-btn-react-container');
    }

    t.span('.js-plugin-header-btns');

    if (isLoggedIn && showCopyButton && !isTemplate) {
      t.a('.board-header-btn.js-copy-board', { href: '#' }, function () {
        t.icon('board', { class: 'board-header-btn-icon' });
        return t.span('.board-header-btn-text', () => t.format('copy-board'));
      });
    }

    if (isPluginCleanupEnabled && hasEditPrivileges) {
      t.span('.js-pup-dropdown-list-btn board-header-btn-react-container');
      t.span('.js-butler-header-btns board-header-btn-react-container');
    }

    t.span('.board-header-btn-divider');

    t.span(
      '.js-brita-board-filter-btn-container board-header-btn-react-container',
    );

    return t.a(
      '.board-header-btn.mod-show-menu.js-show-sidebar',
      { href: '#' },
      function () {
        t.icon('overflow-menu-horizontal', { class: 'board-header-btn-icon' });
        return t.span('.board-header-btn-text', () => t.format('show-menu'));
      },
    );
  });

  t.div('#workspaces-auto-name-alert');

  return t.span('#board-header-notification');
});
